import { forwardRef, type Ref, type SVGProps } from "react";
const IconMoreFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 13a3 3 0 1 0 0 6 3 3 0 1 0 0-6m9 0a3 3 0 1 0 0 6 3 3 0 1 0 0-6M7 13a3 3 0 1 0 0 6 3 3 0 1 0 0-6"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMoreFilledSVG);
ForwardRef.displayName = "IconMoreFilled";
export { ForwardRef as IconMoreFilled };
